import React from 'react';
// Brand mark used in the navbar, mobile menu, and footer.
//
// One cut of the wordmark, everywhere. The navbar previously cross-faded
// between a full and a shortened cut on scroll; that's gone — the mark is now
// constant, so the bar reads the same whether the page is at the top or not.
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/5WQggu4FJxUzGiiSgNKAiK/206_proper_web.svg';
/**
 * Resolve the brand logo image URL — kept as a function so the footer's
 * <img>/mask call site reads consistently.
 */
export function getLogoSrc(): string {
  return LOGO_SRC;
}

// TEMPORARY GLOBAL HIDE — every logo across the site is suppressed
// while this flag is true (the Logo component below, plus the inline
// <img> logos in Navbar.tsx that import this constant). To restore the
// logos, flip this back to `false` and re-publish.
export const LOGOS_HIDDEN = false;
interface LogoProps {
  className?: string;
  imgClassName?: string;
  /**
   * The artwork is exported black. Leave this true to keep it black on light
   * surfaces and invert it to white in dark mode; pass false for call sites
   * that are ALWAYS dark, so the mark is always inverted to white.
   */
  invertOnLight?: boolean;
  /** Retained for backwards-compatibility with existing call sites. */
  cycleEvery?: number;
  pinned?: boolean;
  tinted?: boolean;
  tintColor?: string;
}
/**
 * 206Gravel brand mark.
 */
export function Logo({
  className = '',
  imgClassName = 'h-10 w-auto',
  invertOnLight = true
}: LogoProps) {
  // While LOGOS_HIDDEN is true, every Logo instance renders nothing.
  // Flip the constant above to `false` (or remove this block) to restore.
  if (LOGOS_HIDDEN) return null;
  return <span className={`relative inline-flex items-center ${className}`} data-id="element-1252" data-mp="22k2h4vb5fdnz">
      <img src={LOGO_SRC} alt="206Gravel" className={`${imgClassName} block pointer-events-none ${invertOnLight ? '' : 'invert'}`} data-id="element-1253" data-mp="22myg8myqg8e0" />
    </span>;
}